import 'apps/application';

import 'pages/community';
import 'pages/join-us';
import 'pages/tracking-links';
import 'pages/learn';

import 'styles/application';

import countries from '../common/country_names';
Object.keys(countries).forEach(countryIso => {
  import(/* webpackMode: "eager" */ `../images/icons/flags/${countryIso}.svg`);
});

import 'images/icons_v2/check.svg';
import 'images/icons_v2/close.svg';
import 'images/icons_v2/chevron-left.svg';
import 'images/icons_v2/chevron-right.svg';
import 'images/icons_v2/menu.svg';

import 'images/icons/icon-play.svg';
import 'images/icons/icon-refer.svg';
import 'images/icons/icon-x.svg';
import 'images/icons/icon-video-player-play.svg';
import 'images/icons/button-arrow.svg';

import 'images/products/all-flavors.png';
import 'images/products/4-flavors.png';
import 'images/products/devices/juul-device-top-half.png';

import 'images/products/autoship-pods.png';

import 'images/products/subscription-view.png';
import 'images/products/subscription-calendar.png';

import 'images/social/home.jpg';
import 'images/social/default.jpg';
import 'images/social/auto-ship.jpg';
import 'images/social/logo.png';

import 'images/navigation/gold-blush.jpg';
import 'images/navigation/calculator@3x.jpg';
import 'images/navigation/silver-device@3x.jpg';
import 'images/navigation/refer-smoker.jpg';
import 'images/navigation/juul-nora.png';
import 'images/navigation/juul-nora-wide.jpg';
import 'images/navigation/black-wide.jpg';
import 'images/navigation/blue-ribbon.jpg';
import 'images/navigation/juul-pods.png';
import 'images/navigation/starter-kit.jpg';

import 'images/support/support-page-banner.jpg';

import 'apps/application/reactRails';
